module.exports = require("./index.umd.js")
